/**
 * File type constants for exports and downloads.
 * Values match backend ExportFormat enum.
 */
export const Excel = 'Excel'
export const Csv = 'Csv'
export const Json = 'Json'

export const FILE_EXTENSIONS = Object.freeze({
  [Excel]: 'xlsx',
  [Csv]: 'csv',
  [Json]: 'json',
})

export default Object.freeze({ Excel, Csv, Json, FILE_EXTENSIONS })
